import React from 'react'
import Button from '@/shared/components/UI/Button'

const PageFooterActions = ({
  actions = [],
  className = '',
  containerClassName = 'flex items-center justify-between py-v3-sm mb-v3-xxhuge',
  leftActions = [],
  rightActions = []
}) => {
  // Support both flat actions array and grouped leftActions/rightActions
  const hasGroupedActions = leftActions.length > 0 || rightActions.length > 0

  if (!actions || actions.length === 0) {
    if (!hasGroupedActions) {
      return null
    }
  }

  // If using grouped layout
  if (hasGroupedActions) {
    return (
      <div className={`pt-v3-sm ${containerClassName} ${className}`}>
        <div className="flex items-center gap-v3-xs">
          {leftActions.map((action, index) => (
            <Button
              key={`left-${index}`}
              label={action.label}
              variant={action.variant || 'secondary'}
              size={action.size || 'lg'}
              onClick={action.onClick}
              loading={action.loading || false}
              loadingLabel={action.loadingLabel}
              disabled={action.disabled || false}
              className={action.className}
            />
          ))}
        </div>
        <div className="flex items-center gap-v3-xs">
          {rightActions.map((action, index) => {
            const { label, variant, size, icon, onClick, loading, loadingLabel, disabled, className: actionClassName, ...rest } = action
            return (
              <div key={`right-${index}`} {...rest}>
                <Button
                  label={label}
                  variant={variant || 'primary'}
                  size={size || 'lg'}
                  icon={icon}
                  onClick={onClick}
                  loading={loading || false}
                  loadingLabel={loadingLabel}
                  disabled={disabled || false}
                  className={actionClassName}
                />
              </div>
            )
          })}
        </div>
      </div>
    )
  }

  // Original flat layout
  return (
    <div className={`pt-v3-sm ${containerClassName} ${className}`}>
      {actions.map((action, index) => (
        <Button
          key={index}
          label={action.label}
          variant={action.variant || 'primary'}
          size={action.size || 'lg'}
          onClick={action.onClick}
          loading={action.loading || false}
          loadingLabel={action.loadingLabel}
          disabled={action.disabled || false}
          className={action.className}
        />
      ))}
    </div>
  )
}

export default PageFooterActions